// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1JDSM","insightsList":"newBusinessInsightsMenu_insightsList__18a6X","active":"newBusinessInsightsMenu_active__E-rCI"};